<template>
  <span class="time-stamp">
    {{
      $t('session.chat.time', {
        year: year,
        month: month,
        day: day,
      })
    }}
  </span>
</template>

<script lang="ts">
/** Purpose: Render a locale-aware date divider without applying browser timezone conversion. */
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'TimeStamp',
  props: {
    timestamp: {
      type: String,
      default: '2025-01-01 00:00:00',
    },
  },
  setup(props) {
    // 直接对 "YYYY-MM-DD HH:mm:ss" 字符串切片，保证 UI 显示的“年月日”
    // 与后端“墙上时间”完全一致，不引入 new Date() 的时区解析歧义。
    const datePart = computed(() => props.timestamp.split(' ')[0])
    const year = computed(() => datePart.value.split('-')[0])
    const month = computed(() => datePart.value.split('-')[1])
    const day = computed(() => datePart.value.split('-')[2])

    return { year, month, day }
  },
})
</script>

<style lang="less" scoped>
.time-stamp {
  text-align: center;
  margin-top: 24px;
  color: var(--text-3);
  font-size: 10px;
  font-weight: 400;
  line-height: 14px;
}
</style>
